























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import DropZone from '@/components/Views/UI/DropZone.vue';
import {getBaseURL, nil} from '@/common';
import axios, {AxiosRequestConfig} from 'axios';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import ImageGrid from '@/components/Views/UI/ImageGrid.vue';
import {FeathersVuexFindAll} from '@/utils';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';

@Component({
    components: {
        GenericDialog,
        ImageGrid,
        DropZone,
    },
})
export default class ImportDialog extends Mixins(GlobalAlertMixin) {

    get showingResults() {
        return this.results.created > 0 || this.results.updated > 0 || this.results.errors.length > 0;
    }

    get processing() {
        return this.waitingForFile !== '';
    }

    get hasErrors() {
        return this.results.errors.length > 0;
    }

    public open = false;
    public uploading = false;
    public uploadReady = false;
    public multiUploadProgess = 0;

    @Prop({default: '.csv'})
    public accept!: string;

    @Prop({default: false})
    public multiple!: boolean;

    @Prop({default: ''})
    public importType!: string;

    @Prop(Function)
    public params!: () => any;

    @Prop({default: -1})
    public limit!: number;

    @Prop({default: false})
    public showExisting!: boolean;

    public waitingForFile: string = '';
    public results: any = {
        created: 0,
        updated: 0,
        errors: [],
    };
    private emptyResults = {
        created: 0,
        updated: 0,
        errors: [],
    };

    private checkingFileToken?: any = undefined;
    private fileCheckFrequency: number = 1000;
    private files: File[] = [];

    @Watch('waitingForFile')
    public onWaitingForFileChanged(value?: string, oldValue?: string) {
        if (value === '') {
            clearInterval(this.checkingFileToken);
        } else {
            this.checkingFileToken = setInterval(() => {
                this.$FeathersVuex.Upload.get(this.waitingForFile).then((result) => {
                    if (nil(result.importMetadata) || result.importMetadata === '') {
                        return;
                    }
                    this.results = JSON.parse(result.importMetadata);
                    this.waitingForFile = '';
                }).catch((err) => {
                    console.log(err);
                });
            }, this.fileCheckFrequency);
        }
    }

    public async filesDropped(file: File[]) {
        if (this.multiple) {
            this.files = file;
            this.uploadReady = true;
        } else {
            this.fileDropped(file[0]);
        }
    }

    public async doMultipleUpload() {
        if (this.limit !== -1) {
            if (this.files.length > this.limit) {
                this.showAlert(`You can only add ${this.limit} more files`);
                this.files = [];
                return;
            }
        }
        this.uploading = true;
        this.uploadReady = false;
        const formData = new FormData();
        try {
            for (let i = 0; i < this.files.length; i++) {
                console.log(`uploading #${i}`);
                this.multiUploadProgess = (i + 1) / this.files.length;
                this.fileDropped(this.files[i]);
            }
        } catch (err) {
            console.log(err.message);
            this.showAlert(`There was a problem with processing your upload.`, 'error');
        }
        this.uploading = false;
        this.files = [];
    }

    public async fileDropped(file: File) {
        this.waitingForFile = '';
        this.uploading = true;
        this.results = this.emptyResults;
        const url = `${getBaseURL()}/uploads`;
        const formData = new FormData();
        formData.append('file', file);
        const additionalParams = nil(this.params) ? {} : this.params();
        const config: AxiosRequestConfig = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': `Bearer ${this.$store.state.auth.accessToken}`,
            },
            params: {
                purpose: this.importType,
                ...additionalParams,
            },
        };
        try {
            const response = await axios.post(url, formData, config);
            if (response.status === 201) {
                this.files = [];
                this.$emit('onImport', response.data);
                if (this.importType.indexOf('import-') > -1) {
                    this.waitingForFile = response.data._id;
                } else {
                    this.waitingForFile = '';
                }
            } else {
                this.failWithError(`Server responded with ${response.status} error`);
            }
        } catch (e) {
            this.failWithError(e.message);
        }
        if (!this.multiple) {
            this.uploading = false;
        }
        return;
    }
    public failWithError(message) {
        this.showAlert(message);
        this.uploading  = false;
        this.waitingForFile = '';
    }
}
